import microModal from 'micromodal'

const modal = {
    settings: {
        headerElement: document.querySelector('.c-header'),
        navigationElement: document.querySelector('.c-navigation'),
        bodyElement: document.querySelector('body'),
        menuButtonElement: document.querySelector('.c-menu-button'),
        hamBurgerElement: document.querySelector('.hamburger')
    },
    focusSearch: function(modalInstance) {
        const searchInput = modalInstance.querySelector('#modalSearchTerm')
        if (searchInput) {
            setTimeout(() => {
                searchInput.focus()
            }, 50)
        }
    },
    stopVideo: function(modalInstance) {
        const video = modalInstance.querySelector('.video-wrapper__iframe')
        if(video !== null) {
            const iframeSrc = video.src
            video.src = iframeSrc
        }
    },
    closeMobileMenu: function() {
        if(this.settings.headerElement) {
            this.settings.headerElement.classList.remove('c-header--m-active')
            this.settings.navigationElement.classList.remove('c-navigation__mobile-active')
            this.settings.bodyElement.classList.remove('m-overflow-hidden')
            this.settings.menuButtonElement.classList.remove('menu-button--active')
            this.settings.hamBurgerElement.classList.remove('is-active')
        }
    },
    init: function() {
        microModal.init({
            onShow: (modalInstance) => {
                this.closeMobileMenu()
                this.focusSearch(modalInstance)
                this.settings.bodyElement.classList.add('overflow-hidden')
            },
            onClose: (modalInstance) => {
                this.settings.bodyElement.classList.remove('overflow-hidden')
                this.stopVideo(modalInstance)
            }
        })
    }
}

export default modal